import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { GET_PRIZES, GET_REDEMPTIONS_ACTIVITY, ADD_REDEMPTION, UPDATE_REDEMPTION, ADD_ACTIVITY } from "./actionTypes"
import { getPrizesSuccess, getPrizesFail, getRedemptionsActivitySuccess, getRedemptionsActivityFail, addRedemptionSuccess, addRedemptionFail, updateRedemptionSuccess, updateRedemptionFail, addActivitySuccess, addActivityFail } from "./actions"

//Include Both Helper File with needed methods
import { getPrizes, addRedemption, getRedemptionsActivity, updateRedemption, addActivity } from "helpers/fakebackend_helper"

function* fetchPrizes() {
  try {
    const response = yield call(getPrizes)
    yield put(getPrizesSuccess(response))
  } catch (error) {
    yield put(getPrizesFail(error))
  }
}

function* fetchRedemptionsActivity({ payload:  username }) {
  try {
    const response = yield call(getRedemptionsActivity, username)
    yield put(getRedemptionsActivitySuccess(response))
  } catch (error) {
    yield put(getRedemptionsActivityFail(error))
  }
}

function* saveRedemption({ payload: redemption }) {
  try {
    const response = yield call(addRedemption, redemption)
    yield put(addRedemptionSuccess(response))
  } catch (error) {
    yield put(addRedemptionFail(error))
  }
}

function* changeRedemption({ payload: redemption }) {
  try {
    const response = yield call(updateRedemption, redemption)
    yield put(updateRedemptionSuccess(response))
  } catch (error) {
    yield put(updateRedemptionFail(error))
  }
}

function* saveActivity({ payload: activity }) {
  try {
    console.log(activity)
    const response = yield call(addActivity, activity)
    yield put(addActivitySuccess(response))
  } catch (error) {
    yield put(addActivityFail(error))
  }
}


function* plantStoreSaga() {
  yield takeEvery(GET_PRIZES, fetchPrizes)
  yield takeEvery(ADD_REDEMPTION, saveRedemption)
  yield takeEvery(UPDATE_REDEMPTION, changeRedemption)
  yield takeEvery(ADD_ACTIVITY, saveActivity)
  yield takeEvery(GET_REDEMPTIONS_ACTIVITY, fetchRedemptionsActivity)
}

export default plantStoreSaga
